// Depreciation (amortización) — straight-line. An asset's purchase cost is
// spread over its useful life (in in-game weeks) as a NON-CASH expense in the
// P&L (Cuenta de Resultados). Cash flow is unaffected: the cash already left
// when the works were paid (recorded as a capex transaction). Because the cost
// is derived from the asset type, this needs no per-asset bookkeeping and no
// save migration — legacy courts/buildings depreciate from their type cost.

import { GAME_CONFIG } from './gameConfig'
import { getBuildCost } from './facilityRegistry'
import type { Building, BuildingType } from './buildingConfig'
import type { Court } from '@/store/gameStore'

// A year = 12 months * WEEKS_PER_MONTH weeks. Courts ~5 years, buildings ~6.
const WEEKS_PER_YEAR = 12 * GAME_CONFIG.WEEKS_PER_MONTH
export const ASSET_USEFUL_LIFE_WEEKS = {
  court: 5 * WEEKS_PER_YEAR,
  building: 6 * WEEKS_PER_YEAR,
} as const

export function courtCost(type: Court['type']): number {
  return type === 'outdoor' ? GAME_CONFIG.COURT_OUTDOOR_COST : GAME_CONFIG.COURT_INDOOR_COST
}

export function buildingCost(type: BuildingType): number {
  return getBuildCost(type)
}

/** Weekly straight-line depreciation across all current courts + buildings. */
export function getWeeklyDepreciation(courts: Court[], buildings: Building[]): number {
  const courtDep = courts.reduce(
    (sum, c) => sum + courtCost(c.type) / ASSET_USEFUL_LIFE_WEEKS.court,
    0,
  )
  const buildingDep = buildings.reduce(
    (sum, b) => sum + buildingCost(b.type) / ASSET_USEFUL_LIFE_WEEKS.building,
    0,
  )
  return courtDep + buildingDep
}
